package com.devi3east.bashbuddy.common.service

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.http.ContentType
import io.ktor.http.contentType

class AppConfigApi(
    private val client: HttpClient,
    private val baseUrl: String
) {

    suspend fun getAppConfig(): AppConfigResponse {
        val response = client.get("$baseUrl/app-config") {
            contentType(ContentType.Application.Json)
        }
        return response.body()
    }

}